import { useState, useRef, useCallback } from "react";

export function useTimedState(duration = 2000) {
  const [active, setActive] = useState(false);
  const timerRef = useRef(null);

  const trigger = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setActive(true);
    timerRef.current = setTimeout(() => setActive(false), duration);
  }, [duration]);

  return [active, trigger];
}
